import { useQuery } from '@tanstack/react-query';

import {
    eventDashboardStatsQueryOptions,
    selectOrdersStats,
} from '../eventDashboardStatsQueryOptions';

type UseEventDashboardOrdersOptions = {
    eventId: number | undefined;
    timezone: string;
};

/** Orders card hook — shared dashboard cache, `selectOrdersStats` for the card shape. */
export function useEventDashboardOrders({ eventId, timezone }: UseEventDashboardOrdersOptions) {
    return useQuery({
        ...eventDashboardStatsQueryOptions({ eventId, timezone }),
        select: selectOrdersStats,
    });
}
